module.exports = __webpack_public_path__ + "fonts/inconsolata-webfont.0ce0a4ee.woff";